import React from "react";
import { Box, Typography } from "@mui/material";
import colors from "../../constants/colors";

const WebsiteBranding = ({ customStyles, logoURL }) => {
  const styles = { ...localStyles, ...customStyles };

  return (
    <>
      <Typography sx={styles.title}>Name Pilot</Typography>
      <Typography sx={styles.title}>
        AI Brand Name Generation and Analysis
      </Typography>
      <a
        href="https://effigen.ai"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
      >
        <Box sx={styles.effigenContainerStyle}>
          <img src={logoURL} alt="Effigen.AI Logo" style={styles.logoStyle} />
          <Typography
            variant="caption"
            color={styles.effigenCaptionStyle.color}
            sx={styles.effigenCaptionStyle}
          >
            An Effigen.AI App
          </Typography>
        </Box>
      </a>
    </>
  );
};

const localStyles = {
  title: {
    fontSize: "2rem",
    fontWeight: "bold",
    textAlign: "center",
    color: colors.blue_green[800],
    mb: 1,
  },
  titleStyle: {
    fontSize: "2rem",
    fontWeight: "bold",
    textAlign: "center",
    color: colors.blue_green[800],
    mb: 1,
  },
  effigenCaptionStyle: {
    fontSize: "1rem",
    fontWeight: "bold",
    textAlign: "center",
    color: colors.blue_green[800],
    mb: 1,
  },
  effigenContainerStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    mb: 2,
    gap: 1,
  },
  logoStyle: {
    width: "120px",
    height: "120px",
    filter:
      "brightness(0) saturate(100%) invert(74%) sepia(91%) saturate(679%) hue-rotate(169deg) brightness(122%) contrast(95%)",
  },
};

export default WebsiteBranding;
